import React, { useState } from "react";
import Modal from "../../../../components/ui/Modal";
import Button from "../../../../components/ui/Button";
import Input from "../../../../components/ui/Input";
import { TrendingUp, Users, Target, Calendar, DollarSign } from "lucide-react";

const BoostPostModal = ({ isOpen, onClose, post, onConfirm }) => {
  const [budget, setBudget] = useState(500);
  const [duration, setDuration] = useState(3);
  const [placement, setPlacement] = useState("feed");
  
  // Mock calculation for estimated reach
  const estimatedReach = Math.floor(budget * 12.5 * duration);

  const handleConfirm = () => {
    onConfirm({
      postId: post.id,
      budget,
      duration,
      placement,
      estimatedReach
    });
    onClose();
  };

  if (!post) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Boost Post">
      <div className="space-y-6">
        <div className="bg-slate-50 p-4 rounded-lg border border-slate-200">
          <p className="text-sm font-medium text-slate-500 mb-1">Boosting Post:</p>
          <p className="text-slate-800 line-clamp-2">{post.content}</p>
        </div>

        {/* Budget */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            <DollarSign size={16} className="inline mr-1" />
            Total Budget (ETB)
          </label>
          <div className="flex items-center space-x-4">
            <input
              type="range"
              min="100"
              max="10000"
              step="100"
              value={budget}
              onChange={(e) => setBudget(Number(e.target.value))}
              className="flex-1 h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-primary"
            />
            <Input
              type="number"
              value={budget}
              onChange={(e) => setBudget(Number(e.target.value))}
              className="w-24"
            />
          </div>
        </div>

        {/* Duration */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            <Calendar size={16} className="inline mr-1" />
            Duration (Days)
          </label>
          <div className="flex items-center space-x-4">
            <input
              type="range"
              min="1"
              max="30"
              step="1"
              value={duration}
              onChange={(e) => setDuration(Number(e.target.value))}
              className="flex-1 h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-primary"
            />
            <span className="font-semibold text-slate-800 w-12 text-center">{duration}</span>
          </div>
        </div>

        {/* Placement */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            <Target size={16} className="inline mr-1" />
            Placement
          </label>
          <div className="grid grid-cols-2 gap-3">
            <button
              className={`p-3 rounded-lg border text-left transition-colors ${
                placement === "feed"
                  ? "border-primary bg-primary/5 ring-1 ring-primary"
                  : "border-slate-200 hover:bg-slate-50"
              }`}
              onClick={() => setPlacement("feed")}
            >
              <span className="block font-medium text-slate-800">News Feed</span>
              <span className="text-xs text-slate-500">Sponsored post in user feeds</span>
            </button>
            <button
              className={`p-3 rounded-lg border text-left transition-colors ${
                placement === "search"
                  ? "border-primary bg-primary/5 ring-1 ring-primary"
                  : "border-slate-200 hover:bg-slate-50"
              }`}
              onClick={() => setPlacement("search")}
            >
              <span className="block font-medium text-slate-800">Search Results</span>
              <span className="text-xs text-slate-500">Top result for relevant keywords</span>
            </button>
          </div>
        </div>

        {/* Reach Estimate */}
        <div className="bg-purple-50 p-4 rounded-xl border border-purple-100 flex items-center justify-between">
          <div>
            <p className="text-sm text-purple-600 font-medium">Estimated Reach</p>
            <p className="text-xs text-purple-400">People who will see your post</p>
          </div>
          <div className="flex items-center space-x-2 text-purple-700">
            <Users size={20} />
            <span className="text-2xl font-bold">{estimatedReach.toLocaleString()}</span>
          </div>
        </div>

        <div className="flex justify-end space-x-3 pt-4 border-t border-slate-100">
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleConfirm}>
            <TrendingUp size={18} className="mr-2" />
            Boost Now ({budget} ETB)
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default BoostPostModal;
